export const ROUTES = {
  home: "/",
  devicePanel: "/device-panel",
  settings: "/settings",
  device_settings: "/device-settings",
  schedule: "/schedule",
  gallery: "/gallery",
  traps_and_locations: "/traps-locations",
  image_catalog: "/image-catalog",
  admin: "/admin",
  mesh_detail: "/mesh/:id",
  specimen_detail: "/specimen/:id",
  alerts_notifications: "/alerts-notifications",
  location_detail: "/location-detail/:id"
};
